/** Sentinel group key for tasks that don't belong to a repository. */
export const NO_REPOSITORY_GROUP = 'No repository'
